import { NavigationGuardNext, Route } from 'vue-router';
import { LIST_PERMISSION } from '@/constant/ListPermission';

import Permission from './index';

const PermissionClass = new Permission();

export async function permissionClassesFeature(
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) {
  const hasPermission = PermissionClass.can(LIST_PERMISSION.CLASSES);

  if (hasPermission) {
    next();
    return;
  }

  next({
    name: 'Dashboard'
  });
}
